var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Select',{attrs:{"dense":"","hideDetails":"","clearable":"","chips":"","label":"Priorität filtern","multiple":_vm.multiple,"v":_vm.priorities,"items":_vm.items,"loading":_vm.loading,"error":_vm.error},on:{"change":function($event){return _vm.emitChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }